<template>
  <div
    :class="[
      isElementModal ? 'grid grid-cols-10' : 'flex flex-row items-center gap-1',
      { 'pointer-events-none opacity-60': readonly }
    ]"
  >
    <div :class="isElementModal ? 'col-span-1 w-auto' : 'w-18 shrink-0'">
      <SelectComponent
        v-if="index !== 0 && filteredWhereType"
        v-model="localFilter.whereType"
        name="whereType"
        :values="filteredWhereType"
        required
      />
      <div v-else class="pr-1 text-right text-base font-bold">
        {{ $t('global.filter_when') }}
      </div>
    </div>
    <div :class="isElementModal ? 'col-span-3 w-auto' : 'w-56 min-w-0'">
      <SelectComponent
        v-if="index === 0 || filter.whereType"
        v-model="localFilter.column"
        name="column"
        :values="filtersAvailable"
        colored
        required
      />
    </div>
    <div :class="isElementModal ? 'col-span-2 w-auto' : 'w-40 min-w-0'">
      <SelectComponent
        v-if="localFilter.column"
        v-model="localFilter.condition"
        name="condition"
        :values="filteredConditions"
        required
      />
    </div>
    <div :class="isElementModal ? 'col-span-3 w-auto' : 'min-w-0 flex-1'">
      <div v-if="isDateRangeFilter">
        <BaseShowEditDateRangePicker
          v-if="hasDateRangeValues"
          v-model:start="localFilter.values.start"
          v-model:end="localFilter.values.end"
          edition-mode
          required
        />
      </div>
      <SelectComponent
        v-else-if="
          localFilter.condition &&
          selected_column?.type &&
          selected_column?.type === 'select'
        "
        v-model="localFilter.values"
        name="values"
        :values="columnListValues"
        required
        :multiple="['in', 'not_in'].includes(localFilter.condition)"
      />
      <SelectComponent
        v-else-if="
          localFilter.condition &&
          selected_column?.type &&
          selected_column?.type === 'select_colored'
        "
        v-model="localFilter.values"
        name="values"
        :values="columnListValues"
        required
        colored
        :multiple="['in', 'not_in'].includes(localFilter.condition)"
      />
      <BaseShowEditDatePickerv2
        v-else-if="
          selected_column?.type && selected_column?.type === 'select_date'
        "
        v-model:date="localFilter.values"
        edition-mode
      />
      <SelectMultipleAjax
        v-else-if="
          ['select_wiki_simple', 'select_wiki_global'].includes(
            selected_column?.type
          ) && isMultipleCondition
        "
        v-model:value-object="localFilter.values"
        :values="localFilter.values?.map((v) => v.id) ?? []"
        attribute-label="full_name"
        :url="selected_column.values"
        label=""
      />
      <SelectAjax
        v-else-if="
          localFilter.condition &&
          selected_column?.type &&
          (selected_column.type === 'select_wiki_simple' ||
            selected_column.type === 'select_wiki_global')
        "
        v-model:value-object="localFilter.values"
        attribute-label="full_name"
        :url="selected_column.values"
      />
      <SelectUser
        v-else-if="
          selected_column?.type && selected_column.type === 'select_users'
        "
        v-model="localFilter.values"
        name="select_user"
        edition-mode
        :multiple="isMultipleCondition"
      />
      <SelectMultipleAjax
        v-else-if="
          selected_column?.type === 'select_dossier' && isMultipleCondition
        "
        v-model:value-object="localFilter.values"
        :values="localFilter.values?.map((v) => v.id) ?? []"
        url="dossier-for-select"
        attribute-label="title"
        label=""
      />
      <SelectDossier
        v-else-if="
          selected_column?.type && selected_column.type === 'select_dossier'
        "
        v-model:dossier="localFilter.values"
        name="select_dossier"
        label=""
        edition-mode
      />
      <SelectMultipleAjax
        v-else-if="
          selected_column?.type === 'select_person' && isMultipleCondition
        "
        v-model:value-object="localFilter.values"
        :values="localFilter.values?.map((v) => v.id) ?? []"
        url="person-for-select-ajax"
        attribute-label="title"
        label=""
      />
      <SelectPerson
        v-else-if="
          selected_column?.type && selected_column.type === 'select_person'
        "
        v-model:person="localFilter.values"
        name="select_person"
        label=""
        edition-mode
      />
      <SelectMultipleAjax
        v-else-if="
          selected_column?.type === 'select_item' && isMultipleCondition
        "
        v-model:value-object="localFilter.values"
        :values="localFilter.values?.map((v) => v.id) ?? []"
        url="item-for-select"
        attribute-label="name"
        label=""
      />
      <SelectItem
        v-else-if="
          selected_column?.type && selected_column.type === 'select_item'
        "
        v-model:item="localFilter.values"
        name="select_item"
        label=""
        edition-mode
      />
      <BaseShowEditInput
        v-else-if="selected_column?.type && selected_column.type === 'input'"
        v-model="localFilter.values"
        :edition-mode="true"
      />
    </div>
    <div
      :class="
        isElementModal ? 'col-span-1 w-full' : 'flex shrink-0 items-center'
      "
    >
      <BaseButton
        v-if="!isForDoctype && !readonly"
        icon="times"
        color="danger"
        :size="isElementModal ? 'medium' : 'small'"
        @click="() => $emit('delete-line')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import * as _ from 'lodash-es'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import BaseShowEditDatePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDatePickerv2.vue'
import SelectAjax from '@c/SelectAjaxComponent/component/SelectAjax.vue'
import SelectMultipleAjax from '@c/SelectAjaxComponent/component/SelectMultipleAjax.vue'
import SelectUser from '@c/InitialStateFormComponent/SelectUser.vue'
import BaseShowEditDateRangePicker from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDateRangePicker.vue'
import moment from 'moment'
import SelectDossier from '@c/SelectAjaxComponent/SelectDossier.vue'
import SelectPerson from '@c/SelectAjaxComponent/SelectPerson.vue'
import SelectItem from '@c/SelectAjaxComponent/SelectItem.vue'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'

// Conditions expecting an array of values, mirroring FilterConditions::$type
// in the API (App\Enums\Dashboard\FilterConditions). Every other condition
// expects a single value.
const MULTIPLE_VALUE_CONDITIONS = ['in', 'not_in', 'BET']

// FilterConditions::BETWEEN in the API (App\Enums\Dashboard\FilterConditions).
const DATE_RANGE_CONDITION = 'BET'

function valueShapeOf(condition) {
  return MULTIPLE_VALUE_CONDITIONS.includes(condition) ? 'multiple' : 'simple'
}

export default {
  name: 'FilterLineComponent',
  components: {
    BaseShowEditInput,
    SelectItem,
    SelectPerson,
    SelectDossier,
    BaseShowEditDateRangePicker,
    SelectUser,
    SelectAjax,
    SelectMultipleAjax,
    BaseShowEditDatePickerv2,
    SelectComponent,
    BaseButton
  },
  props: {
    filter: {
      type: Array,
      required: true
    },
    filtersAvailable: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    dashboardType: {
      type: String,
      required: false,
      default: ''
    },
    isElementModal: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:filter', 'delete-line'],
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata'
    }),
    localFilter: {
      get() {
        if (this.filter.whereType === 'orWhere') {
          return {
            ...this.filter,
            whereType: 'where'
          }
        }

        return this.filter
      },
      set(value) {
        this.$emit('update:filter', value)
      }
    },
    filteredWhereType() {
      return this.metadata?.enums?.where_types?.filter(
        (whereType) => whereType.id !== 'orWhere'
      )
    },
    isForDoctype() {
      const invoicingDashboardsTypes = [
        'invoice',
        'purchase_order',
        'quote',
        'credit_note',
        'supplier_order'
      ]
      return (
        invoicingDashboardsTypes.includes(this.dashboardType) &&
        this.filter.column === 'doc_type'
      )
    },
    isMultipleCondition() {
      return ['in', 'not_in'].includes(this.localFilter.condition)
    },
    // A date column is declared as a plain `select` of relative dates, so the "between"
    // condition is what switches it to an explicit start/end pair (BBSW-11198). Only the
    // date columns offer that condition; checking the column too keeps a line that still
    // carries it from another column out of this branch.
    isDateRangeFilter() {
      return (
        this.selected_column?.type === 'select_date_range' ||
        (this.localFilter.condition === DATE_RANGE_CONDITION &&
          !!this.selected_column?.conditions?.includes(DATE_RANGE_CONDITION))
      )
    },
    hasDateRangeValues() {
      const values = this.localFilter.values

      return !!values && typeof values === 'object' && !Array.isArray(values)
    },
    filteredConditions() {
      let selectedColumn = this.selected_column
      if (typeof selectedColumn === 'undefined') {
        selectedColumn = this.filtersAvailable.find(
          (column) => column.id === this.filter.column
        )
      }
      return this.metadata.enums.filter_conditions.filter((item) =>
        selectedColumn?.conditions.includes(item.id)
      )
    },
    selected_column() {
      if (this.filter.column) {
        return this.filtersAvailable.find(
          (column) => column.id === this.filter.column
        )
      }
      return {}
    },
    columnListValues() {
      let metadatas = _.get(this.metadata, this.selected_column.values)
      for (let key in metadatas) {
        if (!metadatas[key].name && metadatas[key].full_name) {
          metadatas[key].name = metadatas[key].full_name
        }
      }
      return metadatas
    },
    filterPlaceBaseValue() {
      return {
        id: this.filter?.values?.id ?? this.filter?.values?.searchable?.id,
        title: this.filter?.values?.title
      }
    }
  },
  watch: {
    'localFilter.condition'(newValue, oldValue) {
      // Switching between two conditions that expect the same value shape
      // (is / is not, contains / does not contain) must keep what the user
      // already picked. Only a change of shape invalidates the value.
      if (oldValue && valueShapeOf(newValue) === valueShapeOf(oldValue)) {
        return
      }

      if (newValue === DATE_RANGE_CONDITION) {
        this.localFilter.values = this.defaultDateRangeValues()
      } else if (['in', 'not_in'].includes(newValue)) {
        this.localFilter.values = []
      } else {
        if (this.selected_column?.type === 'select_date_range') {
          this.localFilter.values = {
            start: moment().toDate(),
            end: moment().add(5, 'days').toDate()
          }
        } else {
          this.localFilter.values = []
        }
      }
    },
    'localFilter.column'(newValue) {
      const column = this.filtersAvailable.find((c) => c.id === newValue)
      if (column?.type === 'select_date_range') {
        this.localFilter.values = {
          start: moment().toDate(),
          end: moment().add(5, 'days').toDate()
        }
      }
      //met toutes les valeurs du filtre à nul ?
      // else {
      //   this.localFilter.values = null
      // }

      // A condition the new column does not offer (e.g. "between" kept from a date
      // column) would leave the line inconsistent: drop it, the condition watcher then
      // resets the values and "is" is preselected below when available.
      if (
        column &&
        this.localFilter.condition &&
        !column.conditions?.includes(this.localFilter.condition)
      ) {
        this.localFilter.condition = null
      }

      // Preselect "is" on a fresh line so the common case costs no click.
      if (!this.localFilter.condition && column?.conditions?.includes('=')) {
        this.localFilter.condition = '='
      }
    }
  },
  created() {
    // A saved line restored from the API already carries its pair; this only covers a
    // line whose value shape does not match its condition, so the picker never binds
    // start/end on an array.
    if (this.isDateRangeFilter && !this.hasDateRangeValues) {
      this.localFilter.values = this.defaultDateRangeValues()
    }
  },
  methods: {
    ...mapMutations({ processSetFilterMutation: 'dashboard/setFilter' }),
    // The relative-date options this condition replaces went back one year at most, so
    // that is the range a fresh "between" line starts from.
    defaultDateRangeValues() {
      return {
        start: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  }
}
</script>
